// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Menu, Box, Text, Modal, ActionIcon } from '@mantine/core';
import { IconBallpen, IconDots, IconMailForward, IconSend, IconTrashX } from '@tabler/icons';
import { FC, useContext } from 'react';
import { addDays } from 'date-fns';
import { useDisclosure } from '@mantine/hooks';
import { RecommendationDto } from '../../../Types/RecommendationT';
import { ToastS } from '../../../Service/ToastS';
import { Contact } from '../../../Service/ContactS';
import RecommendationDeleteModal from './Modals/RecommendationDeleteModal';
import { RecommendationContext } from './RecommendationsPane';
import SendMailModal from './Modals/SendMailModal';
import SendAvailabilityMailModal from './Modals/SendAvailabilityMailModal';

interface Props {
  recommendation: RecommendationDto;
  contactEmail: string | null | undefined;
  contact: Contact;
}

const RecommendationActions: FC<Props> = ({ recommendation, contactEmail, contact }) => {
  const { id: recommendationId, lastRequested } = recommendation;
  const [opened, { open, close }] = useDisclosure(false);
  const [modalOpened, { open: openAvailabilityModal, close: closeAvailabilityModal }] = useDisclosure(false);
  const [deleteModalOpened, { open: openDeleteModal, close: closeDeleteModal }] = useDisclosure(false);
  const { removeRecommendation, reload } = useContext(RecommendationContext);

  // eslint-disable-next-line no-underscore-dangle
  const _openAvailabilityModal = () => {
    const queryAvailable = !lastRequested || (lastRequested && addDays(new Date(lastRequested), 1) < new Date());
    if (queryAvailable) {
      openAvailabilityModal();
    } else {
      ToastS.info(
        'query-availability',
        'Die Verfügbarkeit eines Dienstleisters kann nur alle 24 Stunden abgefragt werden.',
      );
    }
  };

  return (
    <Menu shadow="md" width={225} position="bottom-end" transition="scale-y">
      <Menu.Target>
        <ActionIcon size="xs">
          <IconDots />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item icon={<IconSend size={16} />} onClick={open} disabled={!contactEmail}>
          E-Mail senden
        </Menu.Item>
        <Menu.Item icon={<IconMailForward size={16} />} onClick={_openAvailabilityModal}>
          Verfügbarkeit abfragen
        </Menu.Item>
        <Menu.Item color="red" icon={<IconTrashX size={16} />} onClick={openDeleteModal}>
          Löschen
        </Menu.Item>
      </Menu.Dropdown>
      <Modal
        closeOnClickOutside={false}
        size={550}
        transition="slide-down"
        opened={opened}
        onClose={close}
        title={
          <Text size="lg" weight="bolder">
            E-Mail senden
          </Text>
        }
      >
        <SendMailModal recommendation={recommendation} closeModal={close} recommendedContact={contact} />
      </Modal>
      <Modal
        closeOnClickOutside={false}
        size={550}
        transition="slide-down"
        opened={modalOpened}
        onClose={closeAvailabilityModal}
        title={
          <Text size="lg" weight="bolder">
            Verfügbarkeits-Anfrage stellen
          </Text>
        }
      >
        <SendAvailabilityMailModal recommendation={recommendation} reload={reload} provider={contact} />
      </Modal>
      <Modal
        closeOnClickOutside={false}
        size={550}
        transition="slide-down"
        opened={deleteModalOpened}
        onClose={closeDeleteModal}
        title={
          <Text size="lg" weight="bolder">
            Vermittlung löschen?
          </Text>
        }
      >
        <RecommendationDeleteModal
          recommendation={recommendation}
          removeRecommendation={removeRecommendation}
          contactEmail={contactEmail}
          closeModal={closeDeleteModal}
          recommendedContact={contact}
        />
      </Modal>
    </Menu>
  );
};

export default RecommendationActions;
